module.exports = __webpack_public_path__ + "media/PAG91-04.cd87df40.mp3";